import React from 'react';
import moment from 'moment';

import { boatAPI } from 'api/requests';

import Text from 'Components/Text';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';
import FilePicker from 'Components/FilePicker';

export default ({ floatationCapacity, applicationId, isFinalReview, goToStep, boatDetailsRequestInProcess }) => {
  if (boatDetailsRequestInProcess) return null;
  if (!floatationCapacity || !floatationCapacity.files || !floatationCapacity.files.length) return null;

  return (
    <section className='scene_section'>
      <header>Flotation Test Date</header>
      <Text
        mainWrapperClassName='_margin_top_30'
        label='Date'
        value={moment(floatationCapacity.testDate).format('MM / DD / YYYY')}
      />

      <FilePicker
        isEditable={false}
        files={floatationCapacity.files}
        notEditableStateSectionHeader='Flotation Test Reports'
        httpParams={{ currentMethod: boatAPI.downloadReport, currentId: applicationId }}
      />

      {isFinalReview && (
        <Button
          color={buttonColor.planeOrange}
          label='Edit'
          buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
          fontSize={14}
          onClick={() => goToStep(STEP_ID.FLOATATION_CAPACITY, true)}
        />
      )}
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatFloatation.jsx